import {
  Box,
  Input as ChakraInput,
  InputProps as ChakraInputProps,
  Field,
  InputGroup,
} from '@chakra-ui/react'
import { PiWarningCircleFill } from 'react-icons/pi'
import { Tooltip } from 'uikit'
import { FormLabel } from '../Form/FormLabel'

interface InputProps extends ChakraInputProps {
  isInvalid: boolean
  startAddon: React.ReactNode
  endAddon: React.ReactNode
  label: string
  mask: string
  placeholder: string
  value: string
  size: 'md' | 'sm' | 'lg' | 'xl' | '2xl' | '2xs' | 'xs'
  textAlign: 'left' | 'center' | 'right'
  errorText: string
  description: string
}

export const  Input: React.FC<InputProps> = ({
  name,
  isInvalid,
  startAddon,
  endAddon,
  label,
  mask,
  placeholder,
  value,
  size = 'md',
  textAlign = 'left',
  errorText,
  description,
  ...props
}) => {
  return (
    <Field.Root invalid={isInvalid}>
      {label && <FormLabel name={name}>{label}</FormLabel>}
      <InputGroup
        startAddon={startAddon}
        endAddon={endAddon}
        endElement={
          isInvalid && (
            <Tooltip content={errorText}>
              <Box color="orange.400">
                <PiWarningCircleFill size="20px" cursor="pointer" />
              </Box>
            </Tooltip>
          )
        }
      >
        <ChakraInput
          id={name}
          placeholder={placeholder}
          size={size}
          textAlign={textAlign}
          value={value || ''}
          _focus={{
            ringColor: 'gray.500',
            ringOffsetColor: 'gray.500',
            outlineColor: 'gray.500',
            borderColor: 'gray.500',
          }}
          {...props}
        />
      </InputGroup>

      {description && (
        <Box fontSize="0.7rem" color="gray.400" mt={2}>
          {description}
        </Box>
      )}
    </Field.Root>
  )
}
